import { ScreenId } from '@core/router'

const EXCLUDED_SCREENS: ScreenId[] = [ScreenId.AUDIO_EDIT, ScreenId.AUTH, ScreenId.FORGOT_PASSWORD]

export const isExcludedScreen = (screenId: ScreenId): boolean => EXCLUDED_SCREENS.includes(screenId)
